<div class="contents">
  <div class="index-box">{{ templateItem.order }}.{{ templateSubitem.order }}</div>
  <span
    cdkDragHandle
    [ngClass]="{ 'disabled text-navy-400': !template?.permissions?.can_edit || templateItem.subitems.length < 2 }"
    class="icon-draggable text-blue-700 text-[20px] cursor-pointer"
  ></span>
  <app-floating-input
    inputClass="font-normal"
    [name]="'division' + templateSubitem.id"
    [maxLength]="10"
    (ngModelChange)="fieldChanged('division', $event)"
    [ngModel]="templateSubitem.division"
    [verticalSpacing]="false"
    data-cy="division-input-child"
  ></app-floating-input>
  <app-floating-input
    inputClass="font-normal"
    [name]="'cost_type' + templateSubitem.id"
    [maxLength]="20"
    (ngModelChange)="fieldChanged('cost_type', $event)"
    [ngModel]="templateSubitem.cost_type"
    [verticalSpacing]="false"
    data-cy="cost-type-input-child"
  ></app-floating-input>
  <app-floating-input
    inputClass="font-normal"
    [name]="'description' + templateSubitem.id"
    [maxLength]="40"
    (ngModelChange)="fieldChanged('description', $event)"
    [ngModel]="templateSubitem.description"
    [verticalSpacing]="false"
    data-cy="description-input-child"
  ></app-floating-input>
  <span
    [class.disabled]="templateItem?.subitems?.length < 2"
    (click)="minusClicked()"
    class="icon-minus-box add-remove-btn"
  ></span>
  <!--  <span (click)="plusClicked()" class="icon-plus-box text-blue-700 add-remove-btn"></span>-->
</div>
